import {
  ApplicationInsights,
  Snippet,
} from "@microsoft/applicationinsights-web";
import { VueConstructor } from "vue";
import VueRouter from "vue-router";
import winston from "winston";
import {
  ApplicationInsightsTransport,
  Level,
} from "../../../shared/src/logger/appInsightsTransport";

export interface IOptions {
  appInsightsConfig?: Snippet;
  appInsights?: ApplicationInsights;
  router?: VueRouter;
  level?: Level;
  baseName: string;
}

export default class LoggerPlugin {
  static install(Vue: VueConstructor<Vue>, options: IOptions): void {
    Vue.prototype.$logger = new LoggerPlugin(options);
  }

  constructor(options: IOptions) {
    let appInsights: ApplicationInsights;

    if (options.appInsights !== undefined) {
      appInsights = options.appInsights;
    } else if (options.appInsightsConfig !== undefined) {
      appInsights = new ApplicationInsights(options.appInsightsConfig);

      appInsights.loadAppInsights();
    } else {
      throw new Error(
        "Erreur lors de la configuration du logger. Vous devez soit passer une instance de ApplicationInsights ou passer les configurations de premier."
      );
    }

    // Watch route event if router option is defined.
    if (options.router !== undefined) {
      options.router.onReady(() => {
        if (options.router !== undefined) {
          options.baseName = options.baseName || "(Vue App)";

          options.router.beforeEach((route, _from, next) => {
            const name = options.baseName + " / " + route.name;

            appInsights.startTrackPage(name);

            next();
          });

          options.router.afterEach((route) => {
            const name = options.baseName + " / " + route.name;
            const url =
              location.protocol + "//" + location.host + route.fullPath;

            appInsights.stopTrackPage(name, url);
            appInsights.flush();
          });
        }
      });
    }

    return winston.createLogger({
      transports: [
        new ApplicationInsightsTransport({
          appInsights,
          level: options.level || "info",
        }),
      ],
    });
  }
}
